import { CdkTrapFocus } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'lib-custom-workflow-drawer',
  imports: [CdkTrapFocus],
  host: { '(document:keydown.escape)': 'closeRequested.emit()' },
  templateUrl: './custom-workflow-drawer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomWorkflowDrawerComponent {
  title = input.required<string>();
  wide = input(false);
  closeRequested = output<void>();
}
